@let _linkable = linkable();

<div
  #tooltipRef="sntTooltip"
  #container
  [sntTooltip]="infoText"
  [ngClass]="{ 'flex-1': flex() }"
  class="flex flex-col gap-1"
  (click)="onClickDisplayContainer($event)"
>
  <!-- icon -->
  @if (icon || (label && !showLabelOnlyOnEdit)) {
    <div
      class="flex flex-row gap-1"
      [ngClass]="{ 'border-b border-b-slate-100': showLabelBottomBorder }"
    >
      @if (icon) {
        <div
          class="flex items-center justify-center"
          [ngClass]="{ 'h-4 w-4': labelSmall, 'h-6 w-6': !labelSmall }"
        >
          <i class="{{ icon }}" [ngClass]="{ 'text-[10px]': labelSmall }"></i>
        </div>
      }

      <div
        class="flex items-center"
        [ngClass]="{ 'h-6': !labelSmall, 'h-4': labelSmall }"
      >
        @if (label && !showLabelOnlyOnEdit) {
          <span
            [ngClass]="{
              'text-sm': !labelSmall,
              'text-xs': !!labelSmall,
              'text-slate-600': validationStatus === 'valid' && !labelLight,
              'text-slate-400': validationStatus === 'valid' && labelLight,
              'text-red-600': validationStatus === 'invalid'
            }"
          >
            {{ label }}

            @if (isRequired()) {
              <sup class="text-pink-600">*</sup>
            }
          </span>
        }
      </div>
    </div>
  }

  <div
    [ngClass]="{
      'no-border': noBorder,
      'cursor-pointer': enabled,
      'pl-1': (!!icon || !!label) && !noPaddingLeft
    }"
    class="relative flex flex-col flex-1"
    (keydown)="$event.stopImmediatePropagation()"
    (keyup)="$event.stopImmediatePropagation()"
    (click)="
      clickTargetEdit === 'component'
        ? enabled && open(container, tooltipRef)
        : null
    "
  >
    <div
      class="flex flex-row flex-1 transition-colors group-editable items-center"
    >
      @if (
        enabled &&
        showIcon &&
        iconOnTheLeft &&
        (!editInline || (editInline && !isEditing))
      ) {
        <div
          class="flex flex-row gap-1 transition-opacity opacity-0 group-editable-hover:opacity-50"
        >
          <!-- icon pen -->
          <div
            [ngClass]="{
              'w-6': showIconWhenValueEmpty && !value,
              'w-0 group-editable-hover:w-6': !showIconWhenValueEmpty
            }"
            class="flex items-center justify-center transition-all"
            (click)="
              clickTargetEdit === 'icon'
                ? enabled && open(container, tooltipRef)
                : null
            "
          >
            <i class="fa-light fa-pen"></i>
          </div>
        </div>
      }

      <div
        class="relative flex flex-col flex-1 gap-1"
        [ngClass]="{
          'whitespace-nowrap': textNoWrap(),
          'h-fit': !!displayPlaceholder
        }"
      >
        <div
          [ngClass]="{
            'font-bold': fontBold,
            'text-slate-400': textLight,
            underline:
              _linkable &&
              !isEditing &&
              ((editInline && !!value) || !editInline),
            'cursor-pointer': cursor() === 'pointer'
          }"
          class="{{ fontSize ? fontSize : '' }}"
          (click)="_linkable && linkClick.emit()"
        >
          @if (sup) {
            <sup><i class="fa-light fa-asterisk text-[6px]"></i></sup>
          }

          @if (isEditing && editInline) {
            <ng-container [ngTemplateOutlet]="editInlineTemplate">
            </ng-container>
          } @else {
            <div
              [ngClass]="{
                'border-dotted border-b-2 border-slate-100':
                  enabled &&
                  dataType !== 'html' &&
                  ((editInline && !value) || !editInline) &&
                  !displayPlaceholder,
                'border-slate-300 hover:border-slate-600':
                  validationStatus === 'valid',
                'border-red-500':
                  validationTouched && validationStatus === 'invalid'
              }"
            >
              @switch (dataType) {
                @case ("html") {
                  <ng-container
                    [ngTemplateOutlet]="valueHtmlTemplate"
                    [ngTemplateOutletContext]="{ value: value }"
                  ></ng-container>
                }
                @case ("text") {
                  <ng-container
                    [ngTemplateOutlet]="valueTextTemplate"
                    [ngTemplateOutletContext]="{ value: value }"
                  ></ng-container>
                }
                @case ("number") {
                  <ng-container
                    [ngTemplateOutlet]="valueNumberTemplate"
                    [ngTemplateOutletContext]="{ value: value }"
                  ></ng-container>
                }
                @case ("textarea") {
                  <ng-container
                    [ngTemplateOutlet]="valueTextTemplate"
                    [ngTemplateOutletContext]="{ value: value }"
                  ></ng-container>
                }
                @case ("address") {
                  <ng-container
                    [ngTemplateOutlet]="valueTextTemplate"
                    [ngTemplateOutletContext]="{ value: value }"
                  ></ng-container>
                }
                @case ("fiscalCode") {
                  <ng-container
                    [ngTemplateOutlet]="valueTextTemplate"
                    [ngTemplateOutletContext]="{ value: value }"
                  ></ng-container>
                }
                @case ("vatCode") {
                  <ng-container
                    [ngTemplateOutlet]="valueTextTemplate"
                    [ngTemplateOutletContext]="{ value: value }"
                  ></ng-container>
                }
                @case ("boolean") {
                  <ng-container
                    [ngTemplateOutlet]="valueBooleanTemplate"
                    [ngTemplateOutletContext]="{ value: value }"
                  ></ng-container>
                }
                @case ("select") {
                  <ng-container
                    [ngTemplateOutlet]="valueTextTemplate"
                    [ngTemplateOutletContext]="{ value: value }"
                  ></ng-container>
                }
                @case ("lookup") {
                  <ng-container
                    [ngTemplateOutlet]="valueTextTemplate"
                    [ngTemplateOutletContext]="{ value: value }"
                  ></ng-container>
                }
                @case ("date") {
                  <ng-container
                    [ngTemplateOutlet]="valueDateTemplate"
                    [ngTemplateOutletContext]="{ value: value }"
                  ></ng-container>
                }
                @case ("time") {
                  {{ value | dayjs: "LT" }}
                }
                @case ("datetime") {
                  <ng-container
                    [ngTemplateOutlet]="valueDateTimeTemplate"
                    [ngTemplateOutletContext]="{ value: value }"
                  ></ng-container>
                }
                @case ("phoneNumber") {
                  <ng-container
                    [ngTemplateOutlet]="valuePhoneNumberTemplate"
                    [ngTemplateOutletContext]="{ value: value }"
                  ></ng-container>
                }
                @case ("tag") {
                  <ng-container
                    [ngTemplateOutlet]="valueTagTemplate"
                    [ngTemplateOutletContext]="{ value: value }"
                  ></ng-container>
                }
                @case ("percent") {
                  {{ value || 0 | percent: "1.0-1" }}
                }
                @case ("currency") {
                  {{ value || 0 | money }}
                }
                @default {}
              }
            </div>
          }
        </div>
      </div>

      @if (
        enabled &&
        showIcon &&
        !iconOnTheLeft &&
        (!editInline || (editInline && !isEditing))
      ) {
        <div class="relative flex flex-row h-6 gap-0">
          <!-- icon clear  -->
          @if (showEditableClearButton && value) {
            <div
              class="flex items-center justify-center w-6 transition-opacity opacity-0 group-editable-hover:opacity-50"
              (click)="clickTargetEdit === 'icon' ? enabled && onClear() : null"
            >
              <i class="fa-light fa-eraser"></i>
            </div>
          }

          <!-- icon edit -->
          <div
            [ngClass]="{
              'opacity-50': showIconWhenValueEmpty && !value,
              'opacity-0 group-editable-hover:opacity-50':
                !showIconWhenValueEmpty || value
            }"
            class="flex items-center justify-center w-6 transition-opacity"
            (click)="
              clickTargetEdit === 'icon'
                ? enabled && open(container, tooltipRef)
                : null
            "
          >
            <i class="fa-light fa-pen"></i>
          </div>

          @if (enableDelete()) {
            <div
              [ngClass]="{
                'opacity-50': showIconWhenValueEmpty && !value,
                'opacity-0 group-editable-hover:opacity-50':
                  !showIconWhenValueEmpty || value
              }"
              class="flex items-center justify-center w-6 transition-opacity"
              (click)="clickTargetEdit === 'icon' ? enabled && delete() : null"
            >
              <i class="fa-light fa-trash"></i>
            </div>
          }
        </div>
      }
    </div>

    <div
      [ngClass]="{
        invisible: !isUpdating,
        visible: isUpdating
      }"
      class="absolute inset-0 flex flex-row items-center justify-center p-2"
    >
      <div
        [ngClass]="{
          'opacity-0': !isUpdating,
          'opacity-100': isUpdating
        }"
        class="inv absolute inset-0 transition-opacity rounded-md bg-slate-400/25"
      ></div>

      <div
        class="bg-blue-200 rounded-full flex items-center justify-center h-5 w-5"
      >
        <i class="fa-solid fa-floppy-disk text-blue-600 opacity-100"></i>
      </div>
    </div>
  </div>
</div>

<!-- isEditing -->
@if (isEditing && !editInline) {
  <div
    class="fixed inset-0 z-50 bg-slate-900/25"
    (click)="onClickEditContainer($event)"
  >
    <div
      class="absolute flex flex-row gap-1"
      [ngStyle]="{
        'top.px': inputClientRect?.top || 0,
        'left.px': inputClientRect?.left || 0,
        'width.px': editWidth || null
      }"
    >
      <div
        class="flex flex-row flex-1 gap-2 p-2 rounded-md shadow-md bg-slate-50"
      >
        <div class="flex-1 flex flex-col">
          <div class="flex flex-col flex-1 gap-2">
            @if (!showLabelOnlyOnDisplay) {
              <div>
                <span class="text-xs text-slate-400">
                  {{ label }}
                </span>
              </div>
            }

            <!-- html -->
            @if (dataType === "html") {
              <div class="flex rounded-md w-[640px] h-[512px]">
                <snt-wysiwyg-editor
                  #wysiwygEditor
                  [containerMode]="'inside'"
                  [toolbar]="'signature'"
                  [initialContent]="value"
                  [maxImageSize]="256 * 1024"
                  (contentChanged)="
                    onWysiwygEditorContentChanged(wysiwygEditor)
                  "
                >
                </snt-wysiwyg-editor>
              </div>
            }

            <!-- others -->
            @if (
              dataType !== "address" &&
              dataType !== "html" &&
              dataType !== "tag"
            ) {
              <dx-form
                [formData]="formData"
                class="flex-1"
                (onFieldDataChanged)="onFieldDataChanged()"
              >
                <dxi-item itemType="group" [colCount]="3">
                  @if (dataType === "phoneNumber") {
                    <dxi-item
                      [colSpan]="1"
                      dataField="prefixPhone"
                      editorType="dxSelectBox"
                      [editorOptions]="{
                        dataSource: prefixPhoneDataSource,
                        valueExpr: 'value',
                        displayExpr: 'display',
                        layout: 'horizontal',
                        searchEnabled: true
                      }"
                      [label]="{
                        text: 'Prefisso' | transloco,
                        location: 'top'
                      }"
                    >
                    </dxi-item>
                  }

                  <dxi-item
                    dataField="value"
                    [colSpan]="dataType === 'phoneNumber' ? 2 : 3"
                    [label]="{
                      visible: dataType === 'phoneNumber',
                      location: 'top',
                      text: 'Cellulare' | transloco
                    }"
                    [editorType]="dxEditorType"
                    [width]="width"
                    [editorOptions]="{
                      dataSource: dataSource,
                      displayExpr: 'display',
                      valueExpr: 'value',
                      mask: mask,
                      onContentReady: onEditorContentReady,
                      inputAttr: {
                        editableInput: true,
                        class: 'bg-white'
                      },
                      type: dxDateBoxType,
                      interval: dxDateBoxInterval,
                      min: min,
                      max: max,
                      width: dxWidth,
                      searchEnabled: selectSearchEnabled,
                      minSearchLength: selectSearchEnabled
                        ? selectMinSearchLength
                        : undefined,
                      itemTemplate: selectBoxItemTemplate
                        ? selectBoxItemTemplateFn
                        : undefined,
                      step: dataType === 'percent' ? 0.001 : 0,
                      showClearButton: showClearButton,
                      dropDownOptions: {
                        title: lookupTitle,
                        container: editingDropdownOptionsContainerAttachToBody()
                          ? undefined
                          : elementRef.nativeElement
                      },
                      onOpened: onOpened,
                      valueChangeEvent: 'keyup',
                      format: dataType === 'percent' ? '#0.#%' : undefined
                    }"
                    [validationRules]="validationRules()"
                  ></dxi-item>
                </dxi-item>
              </dx-form>
            }

            <!-- address -->
            @if (dataType === "address") {
              <snt-editable-address
                [address]="value!"
                (addressSelected)="onAddressAddressSelectionChanged($event)"
              ></snt-editable-address>
            }

            <!-- fiscal code-->
            @if (dataType === "fiscalCode") {
              <div
                class="-mx-2 border-b-2 border-dashed border-slate-200"
              ></div>

              <div class="flex flex-col gap-1">
                <div>
                  <span class="text-xs text-slate-400">
                    {{ "Assistente al calcolo" | transloco }}
                  </span>
                </div>

                <snt-fiscal-code-helper
                  [codiceFiscaleHelperData]="fiscalCodeHelperData!"
                  [hideCancelConfirmButtons]="true"
                  (result)="onFiscalCodeHelperResult($event)"
                ></snt-fiscal-code-helper>
              </div>
            }

            <!-- vat number info box -->
            @if (dataType === "vatCode") {
              <div class="flex flex-row items-start gap-1">
                <i class="fa-light fa-info-circle text-slate-400"></i>

                <div class="flex flex-col gap-1">
                  <span class="text-xs underline text-slate-400"
                    >{{ "Composizione partita IVA" | transloco }}:
                  </span>

                  @if (!vatNumberForeign) {
                    <div>
                      <span class="text-xs text-slate-400">
                        <span class="italic">{{ "IT" | transloco }}</span
                        >&nbsp;
                        {{ "seguito da 11 caratteri numerici" | transloco }}
                      </span>
                    </div>
                  }

                  @if (vatNumberForeign) {
                    <ul class="list-disc">
                      <li class="text-slate-900">
                        <span class="text-xs text-slate-400">
                          {{
                            "Due caratteri indicanti lo stato, inclusi nella seguente lista"
                              | transloco
                          }} </span
                        >:

                        <div
                          class="flex flex-col h-64 gap-1 px-4 overflow-auto"
                        >
                          <ul class="list-disc">
                            @for (
                              country of VAT_NUMBER_CODE_AND_COUNTRIES;
                              track $index
                            ) {
                              <li class="text-slate-400">
                                <span class="text-xs text-slate-400">
                                  {{ country.code }}, {{ country.name }}
                                </span>
                              </li>
                            }
                          </ul>
                        </div>
                      </li>
                      <li>
                        <span class="text-xs text-slate-400">
                          {{ "9 caratteri numerici casuali" | transloco }}
                        </span>
                      </li>
                    </ul>
                  }
                </div>
              </div>
            }

            <!-- tag -->
            @if (dataType === "tag") {
              <snt-tag-box
                [value]="tagValue()!"
                [valueExpr]="tagDataSourceValueExpr!"
                [displayExpr]="displayExpr"
                [dataSource]="dataSource"
                [searchEnabled]="true"
                [acceptCustomValue]="false"
                [tagTemplate]="tagTemplate"
                [customItemCreateEvent]="''"
                [acceptCustomValue]="false"
                [placeholder]="'Inserisci un tag' | transloco"
                (onValueChanged)="onTagValueChanged($event)"
              ></snt-tag-box>
            }
          </div>

          @if (enableRecalculatePercentage()) {
            <div class="py-2">
              <dx-check-box
                [(value)]="recalculatePercentage"
                [text]="'Ricalcola percentuali' | transloco"
              ></dx-check-box>
            </div>
          }
        </div>

        <div class="flex flex-row items-start gap-1">
          <snt-button-icon
            icon="fa-light fa-check"
            [size]="'xs'"
            class="text-green-400"
            (onClickAsync)="onSave($event)"
          ></snt-button-icon>

          <snt-button-icon
            icon="fa-light fa-xmark"
            [size]="'xs'"
            class="text-red-400"
            (onClickAsync)="onCancel($event)"
          ></snt-button-icon>
        </div>
      </div>
    </div>
  </div>
}

<ng-template #valueBooleanTemplate let-value="value">
  <span>
    {{ value ? "Si" : ("No" | transloco) }}
  </span>
</ng-template>

<ng-template #valueTextTemplate let-value="value">
  @if (value) {
    <span
      class="text-sm"
      [style]="`${!!editInline ? `max-width: ${width}px;` : ''}`"
      [ngClass]="{
        'text-slate-900': validationTouched && validationStatus === 'valid',
        'text-red-500': validationTouched && validationStatus === 'invalid',
        'block overflow-hidden text-ellipsis whitespace-nowrap': !!editInline
      }"
    >
      @if (mailto) {
        <snt-mailto
          [mail]="valueDisplay"
          [hrefClass]="'[&:not(:hover)]:text-slate-900'"
        ></snt-mailto>
      } @else {
        {{ valueDisplay }}
      }
    </span>
  } @else {
    <ng-container [ngTemplateOutlet]="valueEmptyTemplate"></ng-container>
  }
</ng-template>

<ng-template #valueNumberTemplate let-value="value">
  @if (value || value === 0 || value === undefined) {
    <span
      class="text-sm"
      [ngClass]="{
        'text-slate-900': validationTouched && validationStatus === 'valid',
        'text-red-500': validationTouched && validationStatus === 'invalid'
      }"
      >{{ value || 0 }}</span
    >
  }

  @if (value === null) {
    <ng-container [ngTemplateOutlet]="valueEmptyTemplate"></ng-container>
  }
</ng-template>

<ng-template #valuePhoneNumberTemplate let-value="value">
  @if (value) {
    <span>
      <span [class]="cssClassPhoneNumber(value)"></span>
      <span
        class="text-sm ml-1"
        [ngClass]="{
          'text-slate-900': validationTouched && validationStatus === 'valid',
          'text-red-500': validationTouched && validationStatus === 'invalid'
        }"
        >{{ valueDisplay }}</span
      >
    </span>
  } @else {
    <ng-container [ngTemplateOutlet]="valueEmptyTemplate"></ng-container>
  }
</ng-template>

<ng-template #valueTagTemplate let-value="value">
  @if (value && value.length > 0) {
    <div class="flex flex-col gap-1">
      @for (item of value; track item.id) {
        @let _displayExpr = item?.name;
        <span>
          {{ _displayExpr }}
        </span>
      }
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="valueEmptyTemplate"></ng-container>
  }
</ng-template>

<ng-template #valueHtmlTemplate let-value="value">
  @if (value) {
    <div [innerHTML]="value | safeHtml"></div>
  } @else {
    @if (!contentPlaceholderHtml) {
      <ng-container [ngTemplateOutlet]="valueEmptyTemplate"></ng-container>
    } @else {
      <ng-content select="placeholderHtmlDataType"></ng-content>
    }
  }
</ng-template>

<ng-template #valueDateTemplate let-value="value">
  @if (value) {
    <span>{{ valueDisplay | dayjs: dateDisplayFormat }} </span>
  }
  @if (!value) {
    <ng-container [ngTemplateOutlet]="valueEmptyTemplate"></ng-container>
  }
</ng-template>

<ng-template #valueDateTimeTemplate let-value="value">
  @if (value) {
    <span>{{ valueDisplay | dayjs: "LLL" }} </span>
  }
  @if (!value) {
    <ng-container [ngTemplateOutlet]="valueEmptyTemplate"></ng-container>
  }
</ng-template>

<ng-template #valueEmptyTemplate>
  <span
    class="text-sm"
    [style]="`${!!displayPlaceholder ? `max-width: ${width}px;` : ''}`"
    [ngClass]="{
      'text-slate-300': validationStatus === 'valid' && !displayPlaceholder,
      'text-red-300': validationTouched && validationStatus === 'invalid',
      'block overflow-hidden text-ellipsis whitespace-nowrap':
        !!displayPlaceholder
    }"
  >
    @if (enabled) {
      {{
        this.displayPlaceholder || this.placeholder || ("Inserisci" | transloco)
      }}
    }
    @if (!enabled) {
      {{ this.displayPlaceholder || "-" }}
    }
  </span>
</ng-template>

<ng-template #editInlineTemplate>
  <div
    class="relative flex-1 flex flex-col"
    (click)="$event.stopImmediatePropagation(); $event.preventDefault()"
  >
    <div class="flex flex-col flex-1 gap-2">
      <!-- html -->
      @if (dataType === "html") {
        <div class="flex rounded-md w-[640px] h-[512px]">
          <snt-wysiwyg-editor
            #wysiwygEditor
            [containerMode]="'inside'"
            [toolbar]="'signature'"
            [initialContent]="value"
            [maxImageSize]="256 * 1024"
            (contentChanged)="onWysiwygEditorContentChanged(wysiwygEditor)"
          >
          </snt-wysiwyg-editor>
        </div>
      }

      <!-- others -->
      @if (
        dataType !== "address" && dataType !== "html" && dataType !== "tag"
      ) {
        <dx-form
          [formData]="formData"
          class="flex-1"
          (onFieldDataChanged)="onFieldDataChanged()"
        >
          <dxi-item itemType="group" [colCount]="3">
            @if (dataType === "phoneNumber") {
              <dxi-item
                [colSpan]="1"
                dataField="prefixPhone"
                editorType="dxSelectBox"
                [editorOptions]="{
                  dataSource: prefixPhoneDataSource,
                  valueExpr: 'value',
                  displayExpr: 'display',
                  layout: 'horizontal',
                  searchEnabled: true
                }"
                [label]="{
                  text: 'Prefisso' | transloco,
                  location: 'top'
                }"
              >
              </dxi-item>
            }

            <dxi-item
              dataField="value"
              [colSpan]="dataType === 'phoneNumber' ? 2 : 3"
              [label]="{
                visible: dataType === 'phoneNumber',
                location: 'top',
                text: 'Cellulare' | transloco
              }"
              [editorType]="dxEditorType"
              [width]="width"
              [editorOptions]="{
                dataSource: dataSource,
                displayExpr: 'display',
                valueExpr: 'value',
                mask: mask,
                onContentReady: onEditorContentReady,
                inputAttr: {
                  editableInput: true,
                  class: 'bg-white'
                },
                type: dxDateBoxType,
                interval: dxDateBoxInterval,
                min: min,
                max: max,
                width: dxWidth,
                searchEnabled: selectSearchEnabled,
                minSearchLength: selectSearchEnabled
                  ? selectMinSearchLength
                  : undefined,
                itemTemplate: selectBoxItemTemplate
                  ? selectBoxItemTemplateFn
                  : undefined,
                step: dataType === 'percent' ? 0.001 : 0,
                showClearButton: showClearButton,
                dropDownOptions: {
                  title: lookupTitle,
                  container: editingDropdownOptionsContainerAttachToBody()
                    ? undefined
                    : elementRef.nativeElement
                },

                format: dataType === 'percent' ? '#0.#%' : undefined,
                buttons: dataType === 'select' ? selectButtons() : undefined,
                onInitialized: onInlineEditorInitialized,
                onOpened: onOpened,
                onFocusOut: onFocusOutSaveOrCancel
              }"
              [validationRules]="validationRules()"
            ></dxi-item>
            <!-- TODO: capire se gestire/ripristinare (onValueChanged)="onSave()" -->
          </dxi-item>
        </dx-form>
      }

      <!-- address -->
      @if (dataType === "address") {
        <snt-editable-address
          [address]="value!"
          (addressSelected)="onAddressAddressSelectionChanged($event)"
        ></snt-editable-address>
      }

      <!-- fiscal code-->
      @if (dataType === "fiscalCode") {
        <div class="-mx-2 border-b-2 border-dashed border-slate-200"></div>

        <div class="flex flex-col gap-1">
          <div>
            <span class="text-xs text-slate-400">
              {{ "Assistente al calcolo" | transloco }}
            </span>
          </div>

          <snt-fiscal-code-helper
            [codiceFiscaleHelperData]="fiscalCodeHelperData!"
            [hideCancelConfirmButtons]="true"
            (result)="onFiscalCodeHelperResult($event)"
          ></snt-fiscal-code-helper>
        </div>
      }

      <!-- vat number info box -->
      @if (dataType === "vatCode") {
        <div class="flex flex-row items-start gap-1">
          <i class="fa-light fa-info-circle text-slate-400"></i>

          <div class="flex flex-col gap-1">
            <span class="text-xs underline text-slate-400"
              >{{ "Composizione partita IVA" | transloco }}:
            </span>

            @if (!vatNumberForeign) {
              <div>
                <span class="text-xs text-slate-400">
                  <span class="italic">{{ "IT" | transloco }}</span
                  >&nbsp;
                  {{ "seguito da 11 caratteri numerici" | transloco }}
                </span>
              </div>
            }

            @if (vatNumberForeign) {
              <ul class="list-disc">
                <li class="text-slate-900">
                  <span class="text-xs text-slate-400">
                    {{
                      "Due caratteri indicanti lo stato, inclusi nella seguente lista"
                        | transloco
                    }} </span
                  >:
                  <div class="flex flex-col h-64 gap-1 px-4 overflow-auto">
                    <ul class="list-disc">
                      @for (
                        country of VAT_NUMBER_CODE_AND_COUNTRIES;
                        track country
                      ) {
                        <li class="text-slate-400">
                          <span class="text-xs text-slate-400">
                            {{ country.code }}, {{ country.name }}
                          </span>
                        </li>
                      }
                    </ul>
                  </div>
                </li>
                <li>
                  <span class="text-xs text-slate-400">
                    {{ "9 caratteri numerici casuali" | transloco }}
                  </span>
                </li>
              </ul>
            }
          </div>
        </div>
      }
    </div>

    @if (enableRecalculatePercentage()) {
      <div class="py-2">
        <dx-check-box
          [(value)]="recalculatePercentage"
          [text]="'Ricalcola percentuali' | transloco"
        ></dx-check-box>
      </div>
    }

    <!--
                    @if (isUpdating) {
                      <div
                        class="absolute inset-0 flex items-center justify-center bg-slate-400/25 rounded-md"
                        >
                        <i class="fa-duotone fa-solid fa-floppy-disk text-slate-900"></i>
                      </div>
                    }
                    -->
  </div>
</ng-template>
